export let onscroll = (h)=>{
  window.scrollBy({
    top:h,
    behavior:'smooth'
  })
  return
}



// WEBPACK FOOTER //
// ./src/utils/tools.js